import React from 'react';
import { connect } from 'react-redux';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import ProfileForm from '../ProfileForm/ProfileForm';
import ChangePasswordForm from '../ChangePasswordForm/ChangePasswordForm';
import * as userActions from '../../../../redux/user/actions.user';
import * as gitHubIntegrationActions from '../../../../redux/gitHubIntegration/actions.gitHubIntegration';
import ProgressLoader from '../../../components/ProgressLoader/ProgressLoader';
import getPageTitle from '../../../../services/mini/getPageTitle';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import LinkedAccounts from '../LinkedAccounts/LinkedAccounts';
import HistoryKeeper from '../../../../services/HistoryKeeper';
import SettingsHeader from '../SettingsHeader';

class SettingsPage extends React.Component {

    componentDidMount() {
        HistoryKeeper.push();
        document.title = getPageTitle('Profile');
    }

    render() {
        const {
            isUserLoading,
            user,
            updateProfile,
            getGithubLoginName,
            revokeGithubAccess
        } = this.props;
        const { githubLogin } = user;

        return (
            <div className="settings-page">
                <MainHeader>
                    <SettingsHeader />
                </MainHeader>
                {isUserLoading && <ProgressLoader />}
                <div className="settings-page_body">
                    <div className="settings-page_form">
                        <ProfileForm
                            {...user}
                            updateProfile={updateProfile} />
                        <br />
                        <br />
                        <br />
                        <br />
                        <LinkedAccounts
                            githubLogin={githubLogin}
                            getGithubLoginName={getGithubLoginName}
                            revokeGithubAccess={revokeGithubAccess} />
                        <br />
                        <br />
                        <br />
                        <br />
                        <ChangePasswordForm
                            email={user.email}
                            changePassword={this.props.changePassword} />
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps({ user }, ownProps) {
    return {
        user: user,
        isUserLoading: user.isUserLoading
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGithubLoginName: (param) => asyncDispatch(userActions.getGithubLoginName, dispatch, param),
        revokeGithubAccess: (param) => asyncDispatch(gitHubIntegrationActions.revokeGithubAccess, dispatch, param),
        updateProfile: (firstName, lastName, companyName) => dispatch(userActions.updateProfile(firstName, lastName, companyName)),
        changePassword: (email, password, oldPassword) => {
            return new Promise((resolve, reject) => {
                dispatch(userActions.changePassword(email, password, oldPassword, resolve, reject));
            });
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);
